import React from 'react';

// Créditos de la revista, compuestos como el "staff box" de una publicación:
// el cargo en versalitas sobre una regla, y los nombres debajo en serifa.
const CREDITOS = [
  { cargo: 'Presidente', nombres: ['Carlos Fernández Fernández'] },
  { cargo: 'Director', nombres: ['Broswi Gálvez Villafuerte'] },
  {
    cargo: 'Comité Editorial',
    nombres: [
      'Salomé Galdos Cruz',
      'Ludovina Villanueva Núñez',
      'Jorge Sosa Torres',
      'Héctor Mayhuire Rodríguez',
    ],
  },
  { cargo: 'Editora', nombres: ['Gabriela Alosilla Martínez'] },
  { cargo: 'Corrección de estilo', nombres: ['Elizabeht Bautista Toledano'] },
  { cargo: 'Diseño', nombres: ['El Pasto Verde'] },
  { cargo: 'Publicidad', nombres: ['Comunicación Integral y Servicios Generales E. I. R. L.'] },
];

const Historia = () => {
  return (
    <div className="ed-shell ed-pagina">
      <header className="ed-pagina__cabecera">
        <p className="ed-kicker">Revista Institucional de la CCIA</p>
        <h1 className="ed-pagina__titulo">Comité Editorial</h1>
        <p className="ed-pagina__entradilla">
          Quienes hacen posible cada edición de Cámara AQP.
        </p>
      </header>

      <div className="ed-creditos">
        {CREDITOS.map(({ cargo, nombres }) => (
          <section key={cargo} className="ed-creditos__bloque">
            <h2 className="ed-creditos__cargo">{cargo}</h2>
            <ul className="ed-creditos__lista">
              {nombres.map((nombre) => (
                <li key={nombre}>{nombre}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Historia;
